import debounce from 'lodash/fp/debounce'
import throttle from 'lodash/fp/throttle'

async function attachHandlers(el, binding) {
    const options = Object.assign({
        anchor: 'top',
        container: window,
        interval: 20,
        resizePositionDebounce: 100,
        offset: 0,
        once: false
    }, binding.value ? binding.value : {})

    let scrolled = false, ratio = undefined
    let cache, update, calculate, acceptable
    let activated = false

    const isWindow = !(options.container instanceof HTMLElement || typeof options.container === 'string')

    update = () => {
        if (typeof options.container === 'string') {
            const container = document.querySelector(options.container)
            if (container) {
                options.container = container
            }
            else {
                return
            }
        }
        cache = {
            el: el.getBoundingClientRect(),
            containerHeight: isWindow
                ? window.innerHeight
                : options.container.getBoundingClientRect().height
        }
    }
    const updateDebounced = debounce(options.resizePositionDebounce, update) // 리사이즈에서 사용
    const updateThrottled = throttle(options.interval, update) // 스크롤에서 업데이트 할 때 사용

    calculate = (update) => {
        if (activated && options.once) {
            return
        }
        if (typeof options.container === 'string') {
            return
        }
        if (update) {
            updateThrottled()
        }
        let pos, max
        switch (options.anchor) {
            case 'top:top':
                acceptable = cache.el.top <= 0
                break
            case 'bottom':
                acceptable = cache.el.bottom + options.offset < cache.containerHeight
                break
            case 'contain':
                max = cache.containerHeight - cache.el.height
                pos = cache.el.top + options.offset
                ratio = pos / max
                acceptable = ratio <= 1 && ratio >= 0
                break
            case 'display':
                max = cache.containerHeight + cache.el.height
                pos = cache.el.bottom + options.offset
                ratio = pos / max
                acceptable = ratio <= 1 && ratio >= 0
                break
            default:
                // top:bottom
                acceptable = cache.el.top + options.offset < cache.containerHeight
        }
        if (! scrolled && acceptable || acceptable && ratio) {
            scrolled = true
            activated = true
            el.dispatchEvent(new CustomEvent('scrollee', {
                detail: {
                    value: ratio || scrolled,
                    top: cache.el.top - cache.containerHeight
                }
            }))
        }
        else if (scrolled && ! acceptable) {
            scrolled = false
            el.dispatchEvent(new CustomEvent('scrollee', { detail: false }))
        }
    }
    const calculateThrottled = throttle(options.interval, calculate) // 스크롤에서 사용
    update()

    options.container.addEventListener('scroll', options.interval ? calculateThrottled : calculate)
    options.container.addEventListener('resize', updateDebounced)

    return () => {
        options.container.removeEventListener('scroll', options.interval ? calculateThrottled : calculate)
        options.container.removeEventListener('resize', updateDebounced)
    }
}

export const scrollee = {
    inserted: async (el, binding) => {
        el.$$cleanScrollee = await attachHandlers(el, binding)
    },
    unbind: (el) => {
        el.$$cleanScrollee()
    }
}
